import * as React from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import * as yup from 'yup';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LoadingButton from '../lowLevel/LoadingButton';
import Link from '../misc/Link';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles((theme: any) => ({
  text: {
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.brand.greyCyan}`,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  submit: { margin: theme.spacing(2) },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textColor: { color: 'black' },
  fieldContainer: { padding: theme.spacing(2), width: '100%' },
}));

export default function ForgotPassword({ onSubmit, gotToSignIn }) {
  const classes = useStyles();
  return (
    <Formik
      initialValues={{ email: '' }}
      validationSchema={yup.object({
        email: yup
          .string()
          .email('Invalid email')
          .required('Email is required'),
      })}
      onSubmit={async ({ email }) => onSubmit(email)}
    >
      {({ isSubmitting }) => (
        <Form className={classes.root}>
          <div className={classes.fieldContainer}>
            <InputLabel className={classes.textColor} shrink>
              Email
            </InputLabel>
            <Field
              className={classes.text}
              component={TextField}
              name="email"
              type="email"
              fullWidth
              required
            />
          </div>
          <LoadingButton
            className={classes.submit}
            type={'submit'}
            loading={isSubmitting}
          >
            Restore Password
          </LoadingButton>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              gotToSignIn();
            }}
          >
            <Typography variant="body2">Sign in</Typography>
          </Link>
        </Form>
      )}
    </Formik>
  );
}
